import { createAction, props } from '@ngrx/store';
import { DeviceGroup } from '../../../api/models/device-group.model';
import { Theme } from '../../../api/models/theme.model';
import { ScheduleSummary } from '../../../api/models/schedule-summary.model';
import { Update } from '@ngrx/entity';

// export const accountActionTypes = {

// };

export const getScenesAction = createAction(
    '[Scenes] Get Scenes for Location via service',
    props<{ locationId: number }>()
);

export const setScenesAction = createAction(
    '[Scenes] Set Scenes for Location',
    props<{ scenes: DeviceGroup[] }>()
);

export const addSceneSuccess = createAction(
    '[Scenes] Add Scene Success for location',
    props<{ accountId: number, locationId: number, scene: DeviceGroup }>()
);

export const addSceneFail = createAction(
    '[Scenes] Add Scene Fail for location',
);

export const updateSceneSuccess = createAction(
    '[Scenes] Update Scene Success for location',
    props<{ udpate: Update<DeviceGroup> }>()
);

export const UpdateSceneFail = createAction(
    '[Scenes] Update Scene Fail for location',
);

export const deleteSceneSuccess = createAction(
    '[Scenes] Delete Scene from location',
    props<{ accountId: number, locationId: number, sceneId: number }>()
);

export const clear = createAction(
    '[Scenes] Clear all Scenes'
);
export const scenesActionTypes = {
    getScenesAction,
    setScenesAction,
    addSceneSuccess,
    updateSceneSuccess,
    deleteSceneSuccess,
    addSceneFail,
    UpdateSceneFail,
    clear
}
